module.exports = __webpack_public_path__ + "a2f1f2923a326062888c8ddfd41efbc3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-27.png
// module id = 3104
// module chunks = 0